(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ElementsColorService', elementsColorService);

    function elementsColorService(LibrariesAPIService) {
        /**
         * Convert color object to HEX or RGBA web color
         * @param {Object|String} color converts the color object from the color picker or the stored color into HEX or RGBA representation
         */
        function colorToWeb(color) {
            // If the color is not defined, return a default color
            if (!color) {
                return '#000000';
            }

            // Old products only have a HEX or RGBA string as color
            if (typeof color === 'string') {
                return color;
            }
            // New products can have RGB or CMYK colors
            else {
                // This should be the color object from the color picker
                if (color.rgb && color.HEX) {
                    if (color.alpha < 1) {
                        return (
                            'rgba(' +
                            255 * color.rgb.r +
                            ',' +
                            255 * color.rgb.g +
                            ',' +
                            255 * color.rgb.b +
                            ',' +
                            color.alpha +
                            ')'
                        );
                    } else {
                        return '#' + color.HEX;
                    }
                }
                // Object color stored in the database
                else {
                    if (color.alpha < 1) {
                        // Color converter
                        var converter = new Colors();
                        var rgb = converter.convertColor(color.hex.replace('#', ''), 'HEX2RGB');
                        return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + color.alpha + ')';
                    } else {
                        if (color.colorStops || color.colors) {
                            return color;
                        }
                        return color.hex;
                    }
                }
            }
        }

        /**
         * Convert color object to HEX color
         * @param {Object|String} color converts the color object from the color picker or the stored color into HEX or RGBA representation
         */
        function colorToHex(color) {
            const webString = colorToWeb(color);
            return new fabric.Color(webString).toHex();
        }

        function saveDynamicColor(colorToSave, canvasObject, editMode) {
            const colorObj = {
                position: canvasObject.selectedColorPosition,
                hex: '#' + colorToSave.HEX,
                cmyk:
                    colorToSave.cmyk.c + ',' + colorToSave.cmyk.m + ',' + colorToSave.cmyk.y + ',' + colorToSave.cmyk.k,
                alpha: colorToSave.alpha
            };

            if (!canvasObject.colors) {
                canvasObject.colors = [];
            }

            // Check if we already have a color in this position, if we do, overwrite it
            let color = _.find(canvasObject.colors, function (v) {
                return v.position === canvasObject.selectedColorPosition;
            });

            if (color) {
                color = Object.assign(color, colorObj);
            }
            // Otherwise, add the new position
            else {
                canvasObject.colors.push(colorObj);
            }

            if (editMode) {
                canvasObject.setEditedProp('colors');
            }
        }

        function changeDynamicColorPosition(canvasObject, position, colorPicker, canvas) {
            return new Promise(async (resolve, reject) => {
                try {
                    if (typeof position === 'undefined') {
                        resolve();
                        return;
                    }

                    if (position < 1) {
                        position = 1;
                    }
                    canvasObject.selectedColorPosition = position;

                    let color;
                    // If we have a color library, use the positions from it
                    if (canvasObject.colorLibraryId) {
                        color = await LibrariesAPIService.getLibraryElementAtPosition(
                            canvasObject.colorLibraryId,
                            position
                        );
                    } else {
                        if (!canvasObject.colors) {
                            canvasObject.colors = [];
                        }

                        // Get the color at the given position
                        color = _.find(canvasObject.colors, function (v) {
                            return v.position === position;
                        });

                        // Images created before being able to assign multiple colors have the color stored
                        //  in a separated property
                        if (!color && canvasObject.type === 'image-placeholder' && position === 1) {
                            color = {
                                hex: colorToHex(canvasObject.color),
                                alpha: 1
                            };
                        }
                    }

                    let colorString = 'rgba(0,0,0,1)';
                    if (color) {
                        const c = new Colors();
                        const rgb = c.convertColor(color.hex.replace('#', ''), 'HEX2RGB');
                        colorString = `rgba(${rgb.r},${rgb.g},${rgb.b},${color.alpha})`;
                    } else {
                        console.warn('No color found at position: ' + position);
                    }

                    if (colorPicker) {
                        colorPicker.setColor(colorString);
                    }

                    // Set the new color to the element
                    switch (canvasObject.type) {
                        case 'image-placeholder':
                        case 'image':
                            canvasObject.set('imageColor', colorString);
                            break;

                        case 'vector-placeholder':
                            canvasObject.set('svgColor', colorString);
                            break;
                    }

                    canvas.renderAll();
                    resolve();
                } catch (error) {
                    console.error(error);
                    reject(error);
                }
            });
        }

        return {
            colorToWeb: colorToWeb,
            saveDynamicColor: saveDynamicColor,
            changeDynamicColorPosition: changeDynamicColorPosition
        };
    }
})();
